import { TollFreeVerificationStatusResponseSchema } from "@redotech/redo-model/phone/phone-number";
import * as z from "zod/v4";

export const getTollFreeVerificationStatus = {
  name: "getTollFreeVerificationStatus" as const,
  input: z.object({ phoneNumber: z.string() }),
  output: TollFreeVerificationStatusResponseSchema,
};
